import styled from 'styled-components'
import contentWidths from 'const/contentWidths'

const { alertWidth } = contentWidths

export const Container = styled.div`
  display: flex;
  margin: 0 0 32px;
  max-width: ${alertWidth};
  width: 100%;
  & .toastContainer {
    width: 100%;
    justify-content: flex-start;
    display: flex;
    & > div > p:first-child {
      margin-top: 0;
    }
  }
`

export const Message = styled.p`
  margin: 0;
`
